import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ButtonSubmit from "../common/buttonSubmit";
import ButtonWhite from "../common/buttonWhite";
import TitleSection from "../common/titleSection";
import { HttpService } from "../../services/HttpService";
import { useState } from "react";
import { useSelector } from "react-redux";
import { hasModules } from "../../utils/helpers";

const HeaderSection = (props: any) => {
  let title = props.titleSection ?? "";
  let eventHash = props.eventHash || "";
  let visibleButton = props.visibleButton ?? false;
  const [loaderSpinner, setLoaderSpinner] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { eventId, user } = useSelector((state: any) => state.login);

  const loadCitizen = async () => {
    setLoaderSpinner(true);
    try {
      const result = await HttpService.post(
        `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/guestappTokens`,
        {}
      );
      const { guestappToken } = result?.data;
      if (guestappToken) {
        const params = [
          `token=${guestappToken?.token}`,
          // For BackOffice preview show both internal and external timeslot categories.
          `external=2`,
        ];
        window.open(
          `${process.env.REACT_APP_GUESTAPP}/calendar/event/${
            guestappToken?.eventHash
          }?${params.join("&")}`,
          "_blank",
          "noopener,noreferrer"
        );
      }
      setLoaderSpinner(false);
    } catch (error) {
      console.log(error);
      setLoaderSpinner(false);
    }
  };
  const buttonLabel = hasModules(user, "FEDERFARMA_DOCTOR")
    ? t("headerSection.manage-agenda")
    : t("headerSection.edit-agenda");

  return (
    <div className="HeaderSection">
      <div className="row m-0">
        <div className="col-lg-3"></div>
        <div className="col-lg-6 text-center">
          <TitleSection title={title} />
          {eventHash && !hasModules(user, "FEDERFARMA_DOCTOR") && (
            <p>
              <b>{t("regional-code")}:</b> {eventHash}
            </p>
          )}
        </div>
        <div className="col-lg-3 text-lg-right">
          {visibleButton && (
            <>
              {!hasModules(user, "FEDERFARMA_DOCTOR") && (
                <ButtonWhite
                  handleChange={loadCitizen}
                  spinner={loaderSpinner}
                  textButton={t("headerSection.citizen")}
                />
              )}

              <ButtonSubmit
                handleChange={() => {
                  navigate("/editagenda");
                }}
                textButton={buttonLabel}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
